module.exports = __webpack_public_path__ + "static/media/keith_channon.6fe431cc.png";